// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__7xhte","dragIcon":"SortableItem_dragIcon__3XCKz","disabled":"SortableItem_disabled__3UDBx"};